import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type RolesFetchFailedAction = {
	type: 'ROLES_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): RolesFetchFailedAction => ({
	type: 'ROLES_FETCH_FAILED',
	payload,
});
